import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { ProductlistService } from 'src/app/services/productlist-service/productlist.service';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { Params, Router } from '@angular/router';
import { ProductOverview } from 'src/app/model/product-overview/product-overview';
import { MalfunctionService } from 'src/app/services/malfunction-service/malfunction.service';
import { NavbarService } from 'src/app/services/componentServices/navbar-service/navbar-service';
import { MarketplaceService } from 'src/app/services/dataServices/marketplace-service/marketplace.service';
import { BookmarkOverview } from 'src/app/model/bookmark-overview/bookmark-overview';
import { Observable, Subscription } from 'rxjs';
import { ProductInterface } from 'src/app/model/products/product-interface';
import { MatDialog } from '@angular/material/dialog';
import { ProductDetailDisplayFullComponent } from '../marketplace/detail-pages/product-detail-display/product-detail-display-full/product-detail-display-full.component';
import { ProductService } from 'src/app/services/dataServices/product-service/productService';

type GroupedItems = {
    software: BookmarkOverview[],
    zertifizierungen: BookmarkOverview[],
    anbieter: BookmarkOverview[],
    alle: BookmarkOverview[]
};
@Component({
    selector: 'app-product-list',
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss'],
    standalone: false
})
export class ProductListComponent implements OnInit, OnDestroy {
    isLoading: boolean = false;
    showNoResults = {
        alle: false,
        software: false,
        zertifizierungen: false,
        anbieter: false
    };
    groupedItems: GroupedItems = {
        software: [],
        zertifizierungen: [],
        anbieter: [],
        alle: []
    };
    private productListSubscription?: Subscription;

    constructor(
        public productlistService: ProductlistService,
        private malfunctionService: MalfunctionService,
        private dialogService: DialogService,
        private changeDetector: ChangeDetectorRef,
        private navbarService: NavbarService,
        private router: Router,
        private marketplaceService: MarketplaceService,
        private titleService: Title
    ) {
        document.documentElement.style.setProperty('--scrollStatus', 'auto');
    }


    ngOnInit() {
        this.titleService.setTitle('Meine Merkliste - BIMSWARM');
        this.loadProducts();
        this.subscribeToProductList();
    }


    private async loadProducts(): Promise<void> {
        this.isLoading = true;

        try {
            await this.productlistService.getAllProducts();
        } catch (err) {
            console.error('Productlist konnte nicht geladen werden', err);
        } finally {
            this.isLoading = false;
            this.changeDetector.detectChanges();
        }
    }

    private subscribeToProductList(): void {
        this.productListSubscription = this.productlistService.getProductList().subscribe(items => {
            this.groupedItems = this.groupItems(items);

            this.showNoResults = {
                alle: this.groupedItems.alle.length === 0,
                software: this.groupedItems.software.length === 0,
                zertifizierungen: this.groupedItems.zertifizierungen.length === 0,
                anbieter: this.groupedItems.anbieter.length === 0
            };

            this.changeDetector.detectChanges();
        });
    }

    ngOnDestroy() {
        document.documentElement.style.setProperty('--scrollStatus', 'hidden');
        if (this.productListSubscription) {
            this.productListSubscription.unsubscribe();
        }
    }


    groupItems(items: BookmarkOverview[]): GroupedItems {
        const normalizeName = (name: string) =>
            name
                .toLocaleLowerCase('de')
                .normalize('NFKC')
        const seen = new Set<string>();
        const uniqueItems: BookmarkOverview[] = [];
        for (const item of items) {
            const key = normalizeName(item.bookMarkName);
            if (!seen.has(key)) {
                seen.add(key);
                uniqueItems.push(item);
            }
        }
        const sortByName = (arr: BookmarkOverview[]) =>
            arr.sort((a, b) =>
                a.bookMarkName.localeCompare(b.bookMarkName, 'de', { sensitivity: 'base' })
            );
        const software = sortByName(uniqueItems.filter(i => i.displayType === 1));
        const zertifizierungen = sortByName(uniqueItems.filter(i => i.displayType === 0));
        const anbieter = sortByName(uniqueItems.filter(i => i.displayType === 2));

        return {
            software,
            zertifizierungen,
            anbieter,
            alle: [...software, ...zertifizierungen, ...anbieter],
        };
    }
}
